import { render, staticRenderFns } from "./ChatActiveView.vue?vue&type=template&id=07afd5b7&"
import script from "./ChatActiveView.vue?vue&type=script&lang=js&"
export * from "./ChatActiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports